import React from "react";

const Resolution = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        H.
        <span className="text-[#01A7D1] "> DISPUTE RESOLUTION</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        If a dispute arises between you and Yostel, our goal is to provide you
        with a neutral and cost-effective means of resolving the dispute
        quickly. Accordingly, you and Yostel hereby agree to resolve any claim
        or controversy at law and equity that arises out of the Terms of Use or
        the Platform in accordance with this Section H or as we and you
        otherwise agree in writing. Before resorting to the filing of a formal
        lawsuit, we strongly encourage you to first contact us directly to seek
        a resolution via email at hello.yostel@gmail.com. The dispute shall be
        resolved through arbitration by a sole arbitrator appointed by Yostel
        under the Arbitration and Conciliation Act, 1996 with the seat of
        arbitration being New Delhi. The language of Arbitration shall be
        English.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        The Terms of Use shall be governed in all respects by the laws of India
        and any legal proceeding, subject to the above, arising out of this
        Agreement will occur exclusively in the courts located in New Delhi,
        India.
      </p>
    </div>
  );
};

export default Resolution;
